import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { useNavigate } from "react-router";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";
import { getProductColumns } from "../../Components/product/Product.columns";
import { useAdmin } from "../../../context/AdminContext";
import { PageHeader } from "../../Components/common/PageHeader";

export const ProductList = () => {
  const navigate = useNavigate();
  const { getData, patchData, invalidateQuery } = useDataFetch();
  const { admin } = useAdmin();
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  const { data, isLoading } = getData(
    ["product", pagination],
    "/product",
    { enabled: true },
    {
      page: pagination.pageIndex + 1,
      limit: pagination.pageSize,
    }
  );

  const { mutateAsync: toggleProductStatus } = patchData(
    "/product/toggle-status",
    {},
    {
      onSuccess: () => {
        invalidateQuery(["product"]);
      },
    }
  );

  const handleToggleStatus = (product) => {
    const isActive = product.status;
    const actionText = isActive ? "Inactivar" : "Activar";

    Swal.fire({
      title: `¿Quieres ${actionText} este producto?`,
      text: `Producto: ${product.title}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isActive ? "#DC2626" : "#4B36F0",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Sí, ${actionText}`,
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await toggleProductStatus({ id: product.id });
        Swal.fire({
          title: "¡Hecho!",
          text: `El producto ha sido ${isActive ? "inactivado" : "activado"} correctamente.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const columnHelper = createColumnHelper();
  const columns = useMemo(
    () => getProductColumns(columnHelper, navigate, handleToggleStatus, admin?.role),
    [navigate]
  );

  return (
    <Fragment>
      <PageHeader
        title="Productos"
        crumbs={[{ label: "Tienda" }, { label: "Productos" }]}
        actions={
          <button
            type="button"
            className="btn btn-primary btn-sm d-flex align-items-center gap-1"
            disabled={admin?.role === "ASSISTANT"}
            onClick={() => navigate("/product/newProduct")}
          >
            <i className="ri-add-line" /> Registrar producto
          </button>
        }
      />

      <DataTable
        data={data?.data?.products ?? []}
        total={data?.data?.total ?? 0}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay productos para mostrar."
      />
    </Fragment>
  );
};
